import { TaxRateFilters } from '@reliance/types/filters/TaxRateFilters';
import { TaxTableFilters } from '@reliance/types/filters/TaxTableFilters';
import { Rate, TaxTable } from '@reliance/types/models/Tax';
import { useAsync } from 'react-async-hook';
import api from '../common/api';

export const useTaxTables = (filters?: TaxTableFilters) => {
  return useAsync<TaxTable[]>(
    () => api.get<TaxTable[]>('/tax/table', { params: filters }).then(r => r.data),
    [filters]
  );
};

export const useTaxRates = (filters?: TaxRateFilters) => {
  const key = JSON.stringify(filters ?? {});
  return useAsync<Rate[]>(
    () => api.get<Rate[]>('/tax/rate', { params: filters ?? {} }).then((r) => r.data),
    [key]
  );
};